import {
  APIGetRequest,
  APIPostRequest,
  CreateMessagingProviderPayload,
  OrderDetails,
  OrderSummary,
  TicketItemStatus,
} from '@ancon/wildcat-types'

import Request from '../../client/Request'
import endpoints from '../endpoints'

type OrderAPI = {
  get: {
    details: APIGetRequest<
      { order: OrderDetails },
      { outletId: string; orderId: string }
    >
    orderStatus: APIGetRequest<
      { orderSummary: OrderSummary },
      { orderId: string }
    >
    ticketItemsStatus: APIGetRequest<
      {
        timestamp: string
        statuses: Record<string, TicketItemStatus>
      },
      {
        outletId: string
      }
    >
  }
  post: {
    messagingProvider: APIPostRequest<
      {},
      CreateMessagingProviderPayload,
      {
        orderId: string
      }
    >
  }
}

const order: OrderAPI = {
  get: {
    details: new Request(endpoints.core.outlets.byId.orders.byId.details, {
      version: 1.5,
    }).get,
    orderStatus: new Request(endpoints.core.orders.orderStatus.byId.details)
      .get,
    ticketItemsStatus: new Request(
      endpoints.core.outlets.byId.tickets.ticketItemsStatus.list,
    ).get,
  },
  post: {
    messagingProvider: new Request(
      endpoints.core.orders.byId.messagingProviders.list,
    ).post,
  },
}

export default order
